import { render, staticRenderFns } from "./PagedContactCore.vue?vue&type=template&id=7efe0627&"
import script from "./PagedContactCore.vue?vue&type=script&lang=js&"
export * from "./PagedContactCore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports